<template>
  <div>
    <b-card v-if="patient">
      <div slot="header">
        <i class='fa fa-align-justify'></i><strong class='header-spacing'> Patient details</strong>
      </div>
      <b-form-group id="patientNameGroup" label="Name" label-for="patientName" label-cols="5">
        <b-form-input name="patientName" type="text" v-model="patient.displayName" disabled/>
      </b-form-group>
      <b-row class="form-group">
        <b-col cols="6">
          <label for="patientGender">Gender </label>
          <b-form-input id="patientGender" type="text" v-model="patient.gender" disabled></b-form-input>
        </b-col>
        <b-col>
          <label for="patientDOB">Date of Birth </label>
          <b-form-input id="patientDOB" type="text" v-model="dateOfBirth" disabled></b-form-input>
        </b-col>
      </b-row>
      <div class="form-group">
        <label for="patientEmail">Email </label>
        <b-form-input id="patientEmail" type="text" v-model="patient.email" disabled></b-form-input>
      </div>
      <b-row class="form-group">
        <b-col cols="6">
          <label for="patientPhone">Phone </label>
          <b-form-input id="patientPhone" type="text" v-model="patient.phone" dir="ltr" disabled></b-form-input>
        </b-col>
        <b-col cols="6">
          <label for="patientPhone">Home phone </label>
          <b-form-input id="patientPhone" type="text" v-model="homePhone" dir="ltr" disabled></b-form-input>
        </b-col>
      </b-row>
      <div class="form-group" v-if="patient.address">
        <div class="form-group">
          <label for="patientAddressLine1">Line1</label>
          <b-form-input name="patientAddressLine1" type="text" v-model="patient.address.line1" disabled/>
        </div>
        <div class="form-group">
          <label for="patientAddressLine2">Line2</label>
          <b-form-input name="patientAddressLine2" type="text" v-model="patient.address.line2" disabled/>
        </div>
        <div class="form-group">
          <label for="patientAddressCounty">County</label>
          <b-form-input name="patientAddressCounty" type="text" v-model="patient.address.county" disabled/>
        </div>
        <b-row class="form-group">
          <b-col cols="6">
            <label for="patientAddressPostcode">Postcode</label>
            <b-form-input name="patientAddressPostcode" type="text" v-model="patient.address.postcode" disabled/>
          </b-col>
          <b-col>
            <label for="patientAddressCity">City</label>
            <b-form-input name="patientAddressCity" type="text" v-model="patient.address.city" disabled/>
          </b-col>
        </b-row>
        <b-row class="form-group">
          <b-col v-if="hasPatientId" cols="7" style="display:flex; flex-direction:column; width:270px;">
            <label>Patient ID</label>

            <template v-if="isPdf(patient.patientIDUrl)">
              <button
                class="btn btn-outline-primary btn-sm id-btn"
                @click="downloadPdf(patient.patientIDUrl)"
              >
                View
              </button>
            </template>

            <template v-else>
              <img
                :src="patient.patientIDUrl"
                style="max-width:270px; height:auto;"
                alt="Patient ID"
              />
            </template>
          </b-col>

          <b-col cols="12">
          <hr v-if="bookerDetails"/>
          <label v-if="bookerDetails"><strong>Booking made by</strong></label>
          </b-col>
        </b-row>
        <b-row class="form-group" v-if="bookerDetails">
          <b-col cols="12">
            <label>Name</label>
            <b-form-input type="text" :value="bookerDetails.displayName" disabled/>
          </b-col>
        </b-row>
        <b-row class="form-group" v-if="bookerDetails">
          <b-col cols="6">
            <label>Email</label>
            <b-form-input name="bookerEmail" type="text" :value="bookerDetails.email" disabled/>
          </b-col>
          <b-col>
            <label>Phone number</label>
            <b-form-input name="bookerPhone" type="text" :value="bookerDetails.phone" disabled/>
          </b-col>
        </b-row>
        <b-row class="form-group" v-if="bookerDetails">
          <b-col cols="6">
            <label>Relationship</label>
            <b-form-input name="relationship" type="text" :value="bookerPatientRelationship" disabled/>
          </b-col>
          <b-col>
            <label>Date of Birth</label>
            <b-form-input name="bookerDOB" type="text" :value="bookerDateOfBirth" disabled/>
          </b-col>
        </b-row>
      </div>
    </b-card>
  </div>
</template>

<script>
import moment from "moment";
export default {
  name: 'payment-details',
  props: ['patient', 'order'],
  data() {
    return {
      bookerDetails: null,
      loading: false,
      relationshipError: false,
      bookerPatientRelationship: ''
    };
  },
  computed: {
    homePhone: function () {
      return this.patient.preferences.homePhone ? this.patient.preferences.homePhone : 'Not set';
    },
    dateOfBirth: function() {
      return moment(this.patient.dateOfBirth).format('DD MMM YYYY');
    },
    bookerDateOfBirth: function() {
      return this.bookerDetails ? moment(this.bookerDetails.dateOfBirth).format('DD MMM YYYY') : '';
    },
    hasPatientId() {
      const url = this.patient?.patientIDUrl;
      return !!url && url !== 'N/A';
    }
  },
  watch: {
    order: {
      immediate: true,
      handler(newOrder) {
        if (newOrder && !newOrder.bookingForSomeone && newOrder.bookerId) {
          this.fetchBookerDetails(newOrder.bookerId);
        }
      }
    },
    bookerDetails: {
      handler(newBookerDetails) {
        if (newBookerDetails && this.patient && this.order && !this.order.bookingForSomeone) {
          this.fetchRelationship();
        }
      }
    }
  },
  methods: {
    fetchBookerDetails(bookerId) {
      this.loading = true;
      this.$patientService.getPatient(bookerId)
        .then(response => {
          this.bookerDetails = response;
          this.loading = false;
        })
        .catch(error => {
          console.error('Error fetching booker details:', error);
          this.loading = false;
        });
    },
    
    fetchRelationship() {
      if (!this.order.bookerId || !this.patient.id) {
        return;
      }
      
      this.relationshipError = false;
      
      this.$patientService.getBookerPatientRelationship(this.order.bookerId, this.patient.id)
        .then(response => {
          this.bookerPatientRelationship = response.data || 'Relationship not specified';
        })
        .catch(error => {
          console.error('Error fetching relationship:', error);
          this.relationshipError = true;
        });
    },
    
    formatDate(date) {
      return moment(date).format('DD MMM YYYY');
    },

    isPdf(url) {
      if (!url) return false;
      return url.toLowerCase().includes('.pdf');
    },

    downloadPdf(url) {
      const link = document.createElement('a');
      link.href = url;
      link.download = 'patient-id.pdf';
      link.target = '_blank';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }
}
</script>